<template>
  <div class="page-wrapper">
    <div class="content container-fluid">
      <!-- Header -->
      <div class="page-header">
        <div class="row">
          <div
            class="col-sm-12 d-flex align-items-center justify-content-between"
          >
            <div>
              <h3 class="page-title mb-1">Danh sách nội quy và hướng dẫn</h3>
              <ul class="breadcrumb mb-0">
                <li class="breadcrumb-item">
                  <router-link to="/">Dashboard</router-link>
                </li>

                <li class="breadcrumb-item active">
                  Danh sách nội quy (Admin)
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div
          class="card-header d-flex justify-content-between align-items-center"
        >
          <h5 class="mb-0"></h5>
          <router-link to="/noi-quy/them-moi" class="btn btn-primary btn-sm">
            <i class="la la-plus mr-1"></i> Thêm mới
          </router-link>
        </div>
        <div class="card-body">
          <div class="form-row mb-3">
            <div class="col-md-3">
              <label for="filterPhongBan">Phòng ban</label>
              <select
                id="filterPhongBan"
                class="form-control"
                v-model="filterPhongBanId"
              >
                <option :value="null">Tất cả phòng ban</option>
                <option
                  v-for="pb in phongBanOptions"
                  :key="pb.idPhongBan"
                  :value="pb.idPhongBan"
                >
                  {{ pb.tenPhongBan }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="filterChung">Loại áp dụng</label>
              <select
                id="filterChung"
                class="form-control"
                v-model="filterChung"
              >
                <option :value="null">Tất cả</option>
                <option :value="true">Nội quy chung</option>
                <option :value="false">Nội quy riêng</option>
              </select>
            </div>
            <div class="col-md-3">
              <label for="filterLoai">Loại</label>
              <select id="filterLoai" class="form-control" v-model="filterLoai">
                <option :value="null">Tất cả</option>
                <option value="NOIQUY">Nội quy</option>
                <option value="QUYDINH">Quy định</option>
                <option value="HUONGDAN">Hướng dẫn</option>
              </select>
            </div>
            <div class="col-md-3 d-flex align-items-end">
              <button
                class="btn btn-info"
                @click="applyFilters"
                :disabled="store.isLoading"
              >
                <span
                  v-if="store.isLoading"
                  class="spinner-border spinner-border-sm"
                  role="status"
                  aria-hidden="true"
                ></span>
                Tìm kiếm
              </button>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-striped table-hover table-bordered">
              <thead class="thead-light">
                <tr>
                  <th scope="col">STT</th>
                  <th scope="col">Tên</th>
                  <th scope="col">Loại</th>
                  <th scope="col">Phòng ban</th>
                  <th scope="col">Ngày hiệu lực</th>
                  <th scope="col">Người tạo</th>
                  <th scope="col">Hành động</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="store.isLoading">
                  <td colspan="6" class="text-center">
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </td>
                </tr>
                <tr v-else-if="store.error">
                  <td colspan="6" class="text-center text-danger">
                    {{ store.error }}
                  </td>
                </tr>
                <tr v-else-if="store.items.length === 0">
                  <td colspan="6" class="text-center">
                    Không tìm thấy dữ liệu.
                  </td>
                </tr>
                <tr v-else v-for="(item, index) in store.items" :key="item.id">
                  <td>{{ store.page * store.size + index + 1 }}</td>
                  <td>
                    <router-link
                      :to="`/noi-quy/chi-tiet/${item.id}`"
                      class="font-weight-bold"
                    >
                      {{ item.ten }}
                    </router-link>
                  </td>
                  <td>{{ mapLoai(item.loai) }}</td>
                  <td>{{ item.tenPhongBan || "Chung" }}</td>
                  <td>{{ formatDate(item.ngayHieuLuc) }}</td>
                  <td>{{ item.tenNguoiTao }}</td>
                  <td>
                    <div
                      class="d-flex justify-content-center align-items-center"
                    >
                      <router-link
                        :to="`/noi-quy/chi-tiet/${item.id}`"
                        class="btn btn-info btn-sm mr-2"
                        title="Xem"
                      >
                        <i class="la la-eye"></i>
                      </router-link>
                      <router-link
                        :to="`/noi-quy/sua/${item.id}`"
                        class="btn btn-warning btn-sm mr-2"
                        title="Sửa"
                      >
                        <i class="la la-edit"></i>
                      </router-link>
                      <button
                        class="btn btn-danger btn-sm"
                        @click="handleDelete(item.id)"
                        title="Xóa"
                      >
                        <i class="la la-trash"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <nav aria-label="Page navigation" v-if="store.totalPages > 1">
            <ul class="pagination justify-content-center">
              <li class="page-item" :class="{ disabled: store.page === 0 }">
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(store.currentPage - 1)"
                  >Trước</a
                >
              </li>

              <li
                v-for="(page, index) in paginatedPages"
                :key="index"
                class="page-item"
                :class="{
                  active: page === store.currentPage,
                  disabled: page === '...',
                }"
              >
                <span v-if="page === '...'" class="page-link">...</span>

                <a
                  v-else
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(page)"
                  >{{ page }}</a
                >
              </li>

              <li
                class="page-item"
                :class="{ disabled: store.page === store.totalPages - 1 }"
              >
                <a
                  class="page-link"
                  href="#"
                  @click.prevent="changePage(store.currentPage + 1)"
                  >Sau</a
                >
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue";
import { useNoiQuyStore } from "@/stores/noiQuyStore";
import { useRouter } from "vue-router";
import { useToast } from "vue-toastification";
import phongBanService from "@/services/phongBanService";

const store = useNoiQuyStore();
const router = useRouter();
const toast = useToast();

// --- State cho Filters ---
const filterPhongBanId = ref(store.filterPhongBanId);
const filterChung = ref(store.filterChung);
const filterLoai = ref(store.filterLoai);

// TODO: Lấy danh sách phòng ban từ API
const phongBanOptions = ref([]);
const loadingPhongBan = ref(false);
// HÀM TẢI PHÒNG BAN
const loadPhongBanOptions = async () => {
  loadingPhongBan.value = true;
  try {
    // Gọi API service đã cung cấp
    const data = await phongBanService.getActiveOptions();
    phongBanOptions.value = data.data.data || []; // Giả sử API trả về mảng
  } catch (e) {
    toast.error("Không thể tải danh sách phòng ban.");
    phongBanOptions.value = [];
  } finally {
    loadingPhongBan.value = false;
  }
};

// ---  THÊM COMPUTED PROPERTY CHO PHÂN TRANG ---
const paginatedPages = computed(() => {
  const currentPage = store.currentPage; // 1-indexed
  const totalPages = store.totalPages;
  const pagesToShow = [];

  // Số trang hiển thị ở 2 bên của trang hiện tại
  const onEitherSide = 1;

  if (totalPages <= 7) {
    // Nếu tổng số trang nhỏ (<= 7), hiển thị tất cả
    for (let i = 1; i <= totalPages; i++) {
      pagesToShow.push(i);
    }
  } else {
    // Logic phức tạp hơn
    // 1. Luôn thêm trang 1
    pagesToShow.push(1);

    // 2. Tính toán các trang ở giữa
    let startPage = Math.max(2, currentPage - onEitherSide);
    let endPage = Math.min(totalPages - 1, currentPage + onEitherSide);

    // Thêm '...' nếu có khoảng trống sau trang 1
    if (startPage > 2) {
      pagesToShow.push("...");
    }

    // Điều chỉnh nếu đang ở gần đầu
    if (currentPage - onEitherSide <= 1) {
      endPage = Math.min(totalPages - 1, 1 + onEitherSide * 2);
    }

    // Điều chỉnh nếu đang ở gần cuối
    if (currentPage + onEitherSide >= totalPages) {
      startPage = Math.max(2, totalPages - onEitherSide * 2);
    }

    // Thêm các trang ở giữa
    for (let i = startPage; i <= endPage; i++) {
      pagesToShow.push(i);
    }

    // Thêm '...' nếu có khoảng trống trước trang cuối
    if (endPage < totalPages - 1) {
      pagesToShow.push("...");
    }

    // 3. Luôn thêm trang cuối (totalPages)
    pagesToShow.push(totalPages);
  }

  return pagesToShow;
});

// --- Methods ---
const applyFilters = () => {
  store.setFilters({
    phongBanId: filterPhongBanId.value,
    chung: filterChung.value,
    loai: filterLoai.value,
  });
  store.fetchList();
};

const changePage = (page) => {
  if (page < 1 || page > store.totalPages || page === store.currentPage) {
    return;
  }
  store.setPage(page);
};

const handleDelete = (id) => {
  store.deleteNoiQuy(id);
};

const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("vi-VN");
  } catch (e) {
    return dateString;
  }
};

const mapLoai = (loai) => {
  switch (loai) {
    case "HUONGDAN":
      return "Hướng dẫn";
    case "NOIQUY":
      return "Nội quy";
    case "QUYDINH":
      return "Quy định";
    default:
      break;
  }
};
// --- Lifecycle Hooks ---
onMounted(() => {
  store.fetchList();
  loadPhongBanOptions();
});

// Watchers để fetch lại data khi store thay đổi (ví dụ: đổi trang)
watch(
  () => store.page,
  () => {
    store.fetchList();
  }
);
</script>
